export const formatToBRNumber = (value) => {
    if (value === null || value === undefined) {
        return '-';
    }

    return new Intl.NumberFormat('pt-BR').format(value);
};

const formatToPercentage = (number) => {
    return `${Number(number).toFixed(2)}%`;
};

// Padrao decimal dos graficos: duas casas no formato pt-BR (0,50), sem decimais
// quando o valor arredondado e inteiro (10 em vez de 10,00).
export const formatToBRDecimal = (value, fractionDigits = 2) => {
    if (value === null || value === undefined || value === '') {
        return '';
    }

    const parsed = Number(value);

    if (!Number.isFinite(parsed)) {
        return '';
    }

    const isWhole = Number.isInteger(Number(parsed.toFixed(fractionDigits)));

    return parsed.toLocaleString('pt-BR', {
        minimumFractionDigits: isWhole ? 0 : fractionDigits,
        maximumFractionDigits: fractionDigits
    });
};

export const number = {
    formatToBRNumber,
    formatToPercentage,
    formatToBRDecimal
};
